import React from 'react';
import PropTypes from 'prop-types';

import config from '../../../config';

const imgDir = `${config.assets.baseUrl}images`;

const FormTooltip = ({title, text, onClose}) => (
    <div className="tooltip-container">
        <button
            className="tooltip-close-btn"
            type="button"
            onClick={onClose}
            style={{backgroundImage: `url(${imgDir}/close.svg)`}}
        />
        <h3 className="tooltip-title">{title}</h3>
        <div className="tooltip-content">
            <img
                className="tooltip-img"
                src={`${imgDir}/cards/back-of-card.svg`}
                alt="back side of card"
            />
            <p className="tooltip-text">{text}</p>
        </div>
    </div>
);

FormTooltip.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired
};

export default FormTooltip;
